module.exports = __webpack_public_path__ + "static/media/RecollectionsMurrahHallArticles.8ad520b1.pdf";